"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _Disclaimer = _interopRequireDefault(require("../components/Disclaimer"));
var _SubmitBtn = _interopRequireDefault(require("../components/submit/SubmitBtn"));
var _AdyenWidget = _interopRequireDefault(require("../components/paymentMethods/adyen/AdyenWidget"));
var _BillingInfoHeader = _interopRequireDefault(require("../components/header/BillingInfoHeader"));
var _fields = require("../components/fields");
var _NativeWidget = _interopRequireDefault(require("../components/paymentMethods/native-payment/NativeWidget"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var componentMapper = {
  Disclaimer: _Disclaimer.default,
  SubmitBtn: _SubmitBtn.default,
  AdyenWidget: _AdyenWidget.default,
  NativePayment: _NativeWidget.default,
  BillingInfoHeader: _BillingInfoHeader.default,
  NameInput: _fields.NameField,
  EmailInput: _fields.EmailField,
  PhoneInput: _fields.PhoneNumberField
};
var createComponent = function createComponent(block, index) {
  var ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var component;
  switch (block['type']) {
    case 'jsx':
      component = ref ? /*#__PURE__*/_react.default.createElement("div", {
        key: index,
        ref: ref
      }, block.component) : block.component;
      break;
    case 'id':
      {
        var el = document.getElementById(block['id']);
        ref(el); //calling ref itself will update the reference with element
        component = null;
        break;
      }
    default:
      // default component exists
      // eslint-disable-next-line no-prototype-builtins
      if (componentMapper.hasOwnProperty(block.name)) {
        return component = /*#__PURE__*/_react.default.createElement(componentMapper[block.name], {
          key: index,
          block: block,
          inputRef: ref
        });
      }
      // component doesn't exist
      component = /*#__PURE__*/_react.default.createElement(function () {
        return /*#__PURE__*/_react.default.createElement("div", null, "The component ", block.name, " has not been created yet.");
      }, {
        key: index
      });
  }
  return component;
};
exports.createComponent = createComponent;
var buildComponents = function buildComponents(components, referenceContainer, paymentComponent) {
  /**
   * The default order of components would be:
   * Billing Info Header, Email Field, Phone number Field, Name Fields, Payment Component and Submit button
   * respectively.
   **/
  var defaultComponentOrder = [{
    name: 'BillingInfoHeader'
  }, {
    name: 'EmailInput'
  }, {
    name: 'PhoneInput'
  }, {
    name: 'NameInput'
  }, _objectSpread(_objectSpread({}, paymentComponent), {}, {
    name: 'PaymentComponent'
  })];
  components = components || defaultComponentOrder;
  return components.map(function (block, index) {
    var referenceCreator = function referenceCreator(referenceOf) {
      return function (el) {
        if (el) {
          return referenceContainer[referenceOf] = el;
        }
      };
    };
    var component = null;
    switch (block.name) {
      case 'SubmitBtn':
        component = createComponent(block, index, referenceCreator('paymentSubmitBtn'));
        break;
      case 'PaymentComponent':
        component = createComponent(paymentComponent, index, referenceCreator('paymentContainer'));
        break;
      case 'EmailInput':
        component = createComponent(block, index, referenceCreator('emailInputField'));
        break;
      case 'PhoneInput':
        component = createComponent(block, index, referenceCreator('phoneInputField'));
        break;
      case 'NameInput':
        component = createComponent(block, index, referenceCreator('nameInputField'));
        break;
      case 'BillingInfoHeader':
        component = createComponent(block, index, referenceCreator('billingInfoHeader'));
        break;
      default:
        component = createComponent(block, index);
    }
    return component;
  });
};
var _default = buildComponents;
exports.default = _default;